import { API_URL } from '../../../../utils/config';

export const GET_LATEST_BASESTATIONS_URL = `${API_URL}/baseStation/latest`;
export const GET_BASESTATIONS_BY_YEAR_URL = 'https://api.tizeti.com/api/v1/basestation/year';
